<template>
    <basic-container v-if="obj.id" style="width:900px;margin:0 auto;">
        <div class="tar">
            <el-button size="mini" pain @click="closeHandle">返回</el-button>
            <el-button size="mini" type="primary" class="results" @click="printHandle">打印</el-button>
            <el-button size="mini" type="primary" @click="pdfHandle">生成PDF</el-button>
        </div>
        <div ref="printwrap" v-if="img">
            <img :src="img" style="width:100%;height:auto;">
        </div>
        <div style="padding-top:20px;" v-if="!img">
            <div class="pdf-wrapper breakable" id="page1" ref="wrap">
                <div class="water-wrap" v-watermark="{text:deptName+'-公益醒目信息化管理系统'}"></div>
                <div class="pdf-header">
                    <div>
                        <img src="/img/bg/logo4.png" class="logo">
                        <!-- <div class="logo-title">公益项目信息化管理系统</div> -->
                    </div>
                    <div class="txm-container">
                        <div class="txm">
                            <pdf417 :data="obj.orderInitialPlanList[0].specificNu" @pdfImg="getImagePdf417"></pdf417>
                        </div>
                        <div class="label" v-html="strInit(obj.orderInitialPlanList[0].specificNu)"></div>
                    </div>
                </div>
                <div><span class="mr20">案号：<span class="num-family" v-html="strInit(obj.caseArchivedNumber)"></span></span>
                    <span class="mr20"> 订单号：<span class="num-family" v-html="strInit(obj.orderNo)"></span></span>
                    <span class="mr20">初始计划单号：<span class="num-family" v-html="strInit(obj.initialPlanNo)"></span></span>
                </div>
                <div class="pdf-title">具体计划单</div>
                <div class="mb20">根据关于印发《关于晋安区未成年人综合保护工作的实施方案》的通知 晋检发[2021]3号文件有关内容转办该文件，请给予执行。 </div>
                <avue-form :option="option" v-model="obj">
                    <template slot="info">
                        <div class="two-line">
                            <div class="line df">
                                <div class="t-label">户籍地址</div>
                                <div class="t-content">{{obj.orderPersonalData.residenceProvince}}{{obj.orderPersonalData.residenceCity}}{{obj.orderPersonalData.residenceDistrict}}{{obj.orderPersonalData.residenceAddress}}</div>
                            </div>
                            <div class="line df">
                                <div class="t-label">现住地址</div>
                                <div class="t-content">{{obj.orderPersonalData.actualResidenceProvince}}{{obj.orderPersonalData.actualResidenceCity}}{{obj.orderPersonalData.actualResidenceDistrict}}{{obj.orderPersonalData.actualResidentialAddress}}</div>
                            </div>
                        </div>
                    </template>
                    <!-- 头像 -->
                    <template slot="photoUrl">
                        <div class="t-content">
                            <el-image style="width: 100px; height: 100px" :src="obj.orderPersonalData.photoUrl" fit="contain"></el-image>
                        </div>
                    </template>
                    <!-- 涉罪情况描述 -->
                    <template slot="crimeSituation">
                        <div class="t-content">
                            {{obj.crimeSituation}}
                        </div>
                    </template>
                    <!-- 就学情况 -->
                    <template slot="studentStatus" slot-scope="scope">
                        <div class="t-content">{{getValues(scope.dic,obj.orderSocialSurvey.studentStatus)}} {{obj.orderSocialSurvey.school}} {{obj.orderSocialSurvey.theGrade}} {{obj.orderSocialSurvey.theClass}} {{obj.orderSocialSurvey.studentNo}}</div>
                    </template>
                    <!-- 学习经历 -->
                    <template slot="studyExperience" slot-scope="scope">
                        <div class="t-content">{{obj.orderSocialSurvey.studyExperience}}</div>
                    </template>
                    <!-- 就业状态 -->
                    <template slot="employmentStatus" slot-scope="scope">
                        <div class="t-content">{{getValues(scope.dic,obj.orderSocialSurvey.employmentStatus)}} {{obj.orderSocialSurvey.employmentUnit}}</div>
                    </template>
                    <!-- 家庭经济备注 -->
                    <template slot="familyNote" slot-scope="scope">
                        <div class="t-content">{{obj.orderPersonalData.familyNote}}</div>
                    </template>
                    <!-- 危险因素 -->
                    <template slot="hazard" slot-scope="scope">
                        <div class="t-content">{{getValues(scope.dic,obj.hazard)}} {{obj.hazardRemark}}</div>
                    </template>
                    <!-- 紧急服务 -->
                    <template slot="emergencyServices" slot-scope="scope">
                        <div class="t-content">{{getValues(scope.dic,obj.emergencyServices)}} {{obj.emergencyServicesRemarks}}</div>
                    </template>
                    <!-- 曾使用服务 -->
                    <template slot="isServiceSituation" slot-scope="scope">
                        <div class="t-content">
                            <div class="t-content">{{getValues(scope.dic,obj.orderPersonalData.isServiceSituation)}} {{obj.orderPersonalData.serviceSituationRemarks}}</div>
                        </div>
                    </template>
                    <!-- 现使用服务 -->
                    <template slot="serviceSituationRecord" slot-scope="scope">
                        <div class="t-content">
                            <div class="t-content">{{getValues(scope.dic,obj.orderPersonalData.serviceSituationRecord)}} {{obj.orderPersonalData.serviceSituationNow}}</div>
                        </div>
                    </template>
                    <!-- 初始计划单 -->
                    <template slot="initPlan" slot-scope="scope">
                        <div class="t-content">
                            <div v-for="(item,num) in obj.orderInitialPlanList" :key="num" class="detail-i">
                                <div>计划单序号:{{item.orderInitNumber}}</div>
                                <div>机构:{{item.initPlanCreateDeptName}}</div>
                                <div>类型:{{getLabel(item.type,"work_type")}}</div>
                                <div>建议转派机构:{{item.description}}</div>
                                <div>内容:{{item.content}}</div>
                                <div>开始时间:{{item.beginTime}}</div>
                                <div>完成时间:{{item.endTime}}</div>
                            </div>
                            <!-- <avue-crud :data="obj.orderInitialPlanList" :option="initOption"></avue-crud> -->
                        </div>
                    </template>
                    <!-- 具体计划单 -->
                    <template slot="detailInit" slot-scope="scope">
                        <div class="t-content">
                            <div v-for="(plan,num) in obj.orderInitialPlanList" :key="num">
                                <div v-for="(item,index) in plan.orderSpecificList" :key="index" class="detail-i">
                                    <div>初始计划单序号:{{item.orderInitNumber}}</div>
                                    <div>具体计划单序号:{{item.specificNo}}</div>
                                    <div>计划内容:{{getLabel(item.type,"work_type")}}</div>
                                    <div>执行机构:{{item.specificCreateDeptName}}</div>
                                    <div>具体内容:{{item.content}}</div>
                                    <div>执行人:{{item.performName}}</div>
                                    <div v-if="item.deptName">执行机构:{{item.specificCreateDeptName}}</div>
                                    <div v-for="(img,n) in item.orderSpecificImageList" :key="n">
										<img v-for="(imgList,i) in imgListWay(img.imageUrl)" :src="imgList">
                                        <div>{{img.note}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </avue-form>
                <!-- <div class="mt10">参与机构:</div> -->
                <div class="tar pdf-footer">
                    <div>公益项目信息化管理系统</div>
                    <div class="mt20">{{getDateFormate()}}</div>
                </div>
            </div>
        </div>
    </basic-container>
</template>
<script>
// import { initOption } from '@/option/pdf/table'
import { option, initItem, detailItem } from '@/option/pdf/order'
import { previewImg, downloadPDF } from "@/util/pdf"
import mixin from './mixin'
export default {
    mixins: [mixin],
    props: {
        initId: {
            type: 'String'
        }
    },
    data() {
        return {
            option: {
                detail: true,
                labelWidth: 80,
                labelPosition: 'left',
            },
            // initOption: initOption,
        }
    },
    mounted() {
        let optList = []
        optList = optList.concat(option).concat(initItem).concat(detailItem)
        this.option.column = optList
    },
    methods: {
		imgListWay(img){ 
			let imgList = img.split(',');
			return imgList
		},
        pdfHandle() {
            if (!this.img) {
                previewImg(this.$refs.wrap).then(res => {
                    this.img = res
                    this.$nextTick(() => {
                        downloadPDF(this.$refs.printwrap, this.obj.orderPersonalData.name + "-具体计划单")
                    })
                })
            } else {
                downloadPDF(this.$refs.printwrap, this.obj.orderPersonalData.name + "-具体计划单")
            }

        },
    }
};

</script>
<style lang="scss">
@import "@/styles/moudles/pdf.scss";

</style>
